import { Component, signal } from '@angular/core';
import { FooterComponent } from "../../../layouts/footer/footer.component";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { NgIf } from '@angular/common';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-forgot-user-password',
  imports: [FooterComponent, ReactiveFormsModule, NgIf, RouterLink],
  templateUrl: './forgot-user-password.component.html',
  styleUrl: './forgot-user-password.component.css'
})
export class ForgotUserPasswordComponent {
  form!: FormGroup;
  isForgotUsername = true; 
  public isLoading = signal<boolean>(false);

  constructor(private fb: FormBuilder, private router: Router,
    private auth: AuthService,
    private route: ActivatedRoute,
    private _toastrService: ToastrService
  ) {
    this.isForgotUsername = route?.snapshot?.data['userName'] ? true : false;
  }

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm() {
    this.form = this.fb.group({
      userName: ['', [Validators.required, Validators.email]] 
    });
  }

  submit() {
    if (this.form.invalid) return;

    this.isLoading.set(true);

    if(this.isForgotUsername){
      this.sendForgotUserName();
    }else{
      this.sendForgotPassword();
    }
  }

  private sendForgotUserName(){
    this.auth.sendForgotUserName(this.form.get('userName')?.value)
    .subscribe({
      next: res => {
        this.isLoading.set(false);
        if (res?.errors?.length > 0) {
          this._toastrService.error(res.errors[0]);
          return;
        }
        this._toastrService.success('Le hemos enviado por correo electrónico con su nombre de usuario.', 'Correo enviado');
        this.router.navigate(['/login'])
      }, error: errors => {
        this.isLoading.set(false);
        this._toastrService.error(errors[0]);
      }
    });
  }

  private sendForgotPassword(){
    this.auth.sendForgotPassword(this.form.get('userName')?.value)
    .subscribe({
      next: res => {
        this.isLoading.set(false);
        if (res?.errors?.length > 0) {
          this._toastrService.error(res.errors[0]);
          return;
        }
        this._toastrService.success('Le hemos enviado por correo electrónico un enlace para restablecer su contraseña', 'Correo enviado');
        this.router.navigate(['/login'])
      }, error: errors => {
        this.isLoading.set(false);
        this._toastrService.error(errors[0]);
      }
    });
  }
}
